import axios from 'axios';

export const getZipFromIP = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_API2_BASE_URL}/api/ip-geolocation`,
  );
  const zip = response.data.zip;

  if (zip) {
    return zip;
  }

  return null;
};
